import React, { Component } from 'react';
import { Container, Button } from 'library';
import { isMobile } from 'react-device-detect';
import { ajax_wrapper, bound_font_size } from 'functions';
import { FaqChatbot } from 'components';

import Navigation from './navigation';

export default class Underpaying extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: null,
            windowWidth: window.innerWidth,
            copyButtonText: 'Copy',
            copyButtonAnimating: false,
            emailButtonAnimating: false,
        };
        this.click_cta = this.click_cta.bind(this);

        this.handleResize = this.handleResize.bind(this);
        this.handleCopyClick = this.handleCopyClick.bind(this);
        this.handleEmailClick = this.handleEmailClick.bind(this);
      
        // Set flow type in session storage for chatbot
        sessionStorage.setItem('homebase_flow_type', 'underpaying');
    }

    componentDidMount() {
        // Attempt to get user data from global state instead of API call
        const globalUser = window.secret_react_state && window.secret_react_state.user;
        if (globalUser && globalUser.id) {
            console.log("[Underpaying componentDidMount] Using user from global state:", globalUser); // DEBUG
            this.setState({ currentUser: globalUser });
        } else {
            console.log("[Underpaying componentDidMount] No valid user found in global state."); // DEBUG
            this.setState({ currentUser: null }); 
        }

        // Add resize event listener
        window.addEventListener('resize', this.handleResize);
    }
    
    componentWillUnmount() {
        // Clean up the event listener
        window.removeEventListener('resize', this.handleResize);
    }
    
    handleResize() {
        this.setState({ windowWidth: window.innerWidth });
    }

    click_cta() {
        let session_id = localStorage.getItem('session_id');
        if (session_id) {
            let event_data = {
                session_id: session_id,
                event_name: 'underpaying_cta',
                event_data: {},
            };
            ajax_wrapper('POST', '/api/create_event/', event_data, console.log);
        }
        let href = window.location.href;
        href = href.substring(0, href.indexOf(','));

        window.location.href = href + '#exemptions';
    }

    handleCopyClick(referralLink) {
        navigator.clipboard.writeText(referralLink);
        
        // Update button text and start animation
        this.setState({ 
            copyButtonText: 'Copied!',
            copyButtonAnimating: true 
        });
        
        // Reset button after animation
        setTimeout(() => {
            this.setState({ 
                copyButtonText: 'Copy',
                copyButtonAnimating: false 
            });
        }, 1500);
    }
    
    handleEmailClick = (referralLink) => {
        this.setState({ emailButtonAnimating: true });

        const subjectText = "Check out HomeBase!";
        const bodyText =
          `Hey!\n\nI thought you might be interested in checking out HomeBase. ` +
          `They helped me understand my property taxes better!\n\n` +
          `You can use this link to learn more: ${referralLink}\n\nBest,\n[Your Name]`;

        const subjectEncoded = encodeURIComponent(subjectText);
        const bodyEncoded = encodeURIComponent(bodyText);
        const mailto = `mailto:?subject=${subjectEncoded}&body=${bodyEncoded}`;

        // Helper to reset button animation
        const resetAnimation = () => {
          setTimeout(() => this.setState({ emailButtonAnimating: false }), 500);
        };

        // Try the modern Web Share API (primarily for mobile devices)
        if (navigator.share && typeof isMobile !== 'undefined' && isMobile) {
          navigator
            .share({ title: "HomeBase referral", text: bodyText })
            .catch(() => {
            })
            .finally(() => resetAnimation());
          return; 
        }

        // Desktop / Fallback: Attempt to fire mailto link using an iframe.
        let mailtoAttempted = false;
        try {
          const iframe = document.createElement('iframe');
          iframe.style.display = 'none';
          iframe.src = mailto;
          document.body.appendChild(iframe);
          mailtoAttempted = true;

          setTimeout(() => {
            try {
              if (iframe.parentNode === document.body) {
                document.body.removeChild(iframe);
              }
            } catch (e) {
              console.warn("Could not remove mailto iframe", e);
            }
          }, 1500);
        } catch (e) {
          console.error("Error attempting to open mailto iframe:", e);
        }

        // Always offer clipboard text for desktop, and as a general fallback.
        setTimeout(() => {
          navigator.clipboard.writeText(bodyText)
            .then(() => {
              alert(
                `We tried to open your email client with the referral message.

` +
                `If it didn't open, or if the email body appears empty (which can sometimes occur on systems like Linux), ` +
                `we've copied the full message and subject to your clipboard.

` +
                `You can now paste it into a new email.

` +
                `Subject: ${subjectText}

` +
                `Message (copied):
${bodyText}`
              );
            })
            .catch(clipboardErr => {
              console.error('Failed to copy to clipboard:', clipboardErr);
              // Fallback if clipboard API itself fails: show all text in the alert.
              alert(
                `We tried to open your email client.

` +
                `If it didn't open or if the email body is empty, please manually copy the text below:

` +
                `------------------------------
` +
                `Subject: ${subjectText}

` +
                `Message:
${bodyText}
` +
                `------------------------------`
              );
            })
            .finally(() => {
              resetAnimation();
            });
        }, mailtoAttempted ? 700 : 100); // If mailto iframe was attempted, wait a bit longer for UI to settle.
      };
      

    render() {
        let navigation = <Navigation />;
        const { currentUser, windowWidth, copyButtonText, copyButtonAnimating, emailButtonAnimating } = this.state;

        // --- Debugging currentUser state --- 
        console.log("[Underpaying render] State currentUser:", currentUser);
        // --- End Debugging ---

        let header_font_size = bound_font_size(4.2, 80, 40);

        // Generate referral link only if we have a real user ID
        const baseUrl = `${window.location.protocol}//${window.location.host}`;
        const isRealUser = currentUser && currentUser.id && typeof currentUser.id === 'string' && !currentUser.id.startsWith('demo-user');
        const referralLink = isRealUser ? `${baseUrl}/?ref=${currentUser.id}` : ''; 
        
        // Dynamic positioning for the referral box based on screen size
        const isLargeScreen = windowWidth > 1200;
        const isMediumScreen = windowWidth <= 1200 && windowWidth > 992;
        const isSmallScreen = windowWidth <= 992;
        
        return (
            <div
                className="hero-section gradient-background-underpaying"
                style={{
                    marginBottom: '40px',
                    position: 'relative',
                }}
            >
                <div className="confetti d-none d-lg-block"></div>
                <div className="confetti d-none d-lg-block right"></div>
                <Container
                    min_height={true}
                    className="slide nav-wrapper"
                    style={{
                        textAlign: 'center',
                        maxWidth: '100%',
                        position: 'relative',
                        zIndex: '20',
                    }}
                >
                    <div 
                        className="position-relative" 
                        style={{ 
                            display: 'flex', 
                            flexDirection: isSmallScreen ? 'column' : 'row',
                            justifyContent: 'center',
                            alignItems: isSmallScreen ? 'center' : 'flex-start',
                            width: '100%'
                        }}
                    >
                        <div 
                            className="main-content" 
                            style={{ 
                                position: 'relative',
                                width: isSmallScreen ? '100%' : '60%',
                                textAlign: 'center',
                                padding: isSmallScreen ? '10px' : '20px 0',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                zIndex: 20,
                            }}
                        >
                            <div
                                id="propertysearch"
                                style={{
                                    fontSize: header_font_size + 'vw',
                                    fontWeight: '500',
                                    lineHeight: 'normal',
                                    textAlign: 'center',
                                }}
                            >
                                <div>Congrats! You are...</div>
                                <div
                                    className="gradient-color"
                                    style={{ fontSize: '1.4em' }}
                                >
                                    Underpaying ↓
                                </div>
                            </div>

                            {/* Referral box always below the Underpaying text */}
                            {currentUser && (
                                <div style={{
                                    backgroundColor: 'white',
                                    padding: '20px',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    textAlign: 'center',
                                    zIndex: 30,
                                    maxWidth: isSmallScreen ? '90%' : '400px',
                                    margin: '110px auto 24px auto',
                                }}>
                                    <h3 style={{ 
                                        fontSize: header_font_size / (isSmallScreen ? 3.5 : 2.5) + 'vw',
                                        marginBottom: '15px',
                                        background: 'linear-gradient(45deg, #FC7F53, #5E50F7)',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                    }}>
                                        Don't be selfish! Help your friends and family save by referring them!
                                    </h3>
                                    <div style={{ 
                                        display: 'flex',
                                        gap: '10px',
                                        marginBottom: '15px'
                                    }}>
                                        <input
                                            type="text"
                                            value={referralLink}
                                            readOnly
                                            disabled={!isRealUser}
                                            style={{
                                                flex: 1,
                                                padding: '8px 12px',
                                                borderRadius: '6px',
                                                border: '1px solid #ddd',
                                                fontSize: header_font_size / (isSmallScreen ? 5 : 4) + 'vw'
                                            }}
                                        />
                                        <Button
                                            onClick={() => this.handleCopyClick(referralLink)}
                                            disabled={!isRealUser || copyButtonAnimating}
                                            style={{
                                                border: 'none',
                                                padding: '4px 12px',
                                                borderRadius: '6px',
                                                background: 'linear-gradient(45deg, #FC7F53, #5E50F7)',
                                                boxShadow: 'none',
                                                outline: 'none',
                                                color: 'white',
                                                fontSize: header_font_size / (isSmallScreen ? 5 : 4) + 'vw',
                                                transition: 'all 0.3s ease',
                                                transform: copyButtonAnimating ? 'scale(1.1)' : 'scale(1)',
                                                opacity: copyButtonAnimating ? '0.9' : '1',
                                            }}
                                        >
                                            {copyButtonText}
                                        </Button>
                                    </div>
                                    <Button
                                        onClick={() => this.handleEmailClick(referralLink)}
                                        disabled={!isRealUser || emailButtonAnimating}
                                        style={{
                                            width: '100%',
                                            border: 'none',
                                            padding: '4px 12px',
                                            borderRadius: '6px',
                                            background: 'linear-gradient(45deg, #FC7F53, #5E50F7)',
                                            boxShadow: 'none',
                                            outline: 'none',
                                            color: 'white',
                                            fontSize: header_font_size / (isSmallScreen ? 5 : 4) + 'vw',
                                            transition: 'all 0.3s ease',
                                            transform: emailButtonAnimating ? 'scale(1.05)' : 'scale(1)',
                                            opacity: emailButtonAnimating ? '0.9' : '1',
                                        }}
                                    >
                                        Share via Email
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>

                    <div style={{ 
                        marginTop: isSmallScreen && currentUser ? '20px' : '15%',
                        clear: isSmallScreen ? 'both' : 'none',
                        textAlign: 'center',
                        width: '100%'
                    }}>
                        <h4
                            style={{
                                fontSize: header_font_size / 2 + 'vw',
                                display: 'inline-block',
                                margin: '0px 0px 10px',
                            }}
                        >
                            However, you can save{' '}
                            <span className="gradient-color">hundreds</span> more.{' '}
                            <span className="gradient-color">Click the Button</span>{' '}
                            to see how!
                        </h4>
                        <br />
                        <Button
                            className="gradient-border"
                            onClick={this.click_cta}
                            style={{
                                marginBottom: '32px',
                            }}
                        >
                            <div
                                className="gradient-border-content"
                                style={{
                                    fontWeight: 500,
                                    fontSize: header_font_size / 3 + 'vw',
                                }}
                            >
                                {'Take Me There'}
                            </div>
                        </Button>
                    </div>

                    {navigation}
                </Container>
                <FaqChatbot />
            </div>
        );
    }
}
